import { useTheme } from '@mui/material';
import { DetailItem, ItemListCard } from 'components/ItemListCard';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { skillLevelOptions } from './constants';

export const HardSkillDetailsList = ({
  values,
  onAddClick,
  onEditHardSkill,
  onDeleteHardSkill
}: {
  values: CVBuilderFormValues;
  onAddClick: () => void;
  onEditHardSkill?: (index: number) => void;
  onDeleteHardSkill?: (index: number) => void;
}) => {
  const theme = useTheme();

  const hardSkillsMissing = !values.hardSkills?.length;

  return (
    <ItemListCard
      isEmpty={hardSkillsMissing}
      showAddButton={true}
      addButtonLabel={getTrans(
        'cvBuilderPage.hardSkills.button.addHardSkill.label'
      )}
      addButtonTestId="show-add-hard-skill-form-button"
      onAddClick={onAddClick}
      emptyStateText={
        hardSkillsMissing
          ? getTrans('cvBuilderPage.hardSkills.button.addHardSkill.body')
          : undefined
      }
      sx={{
        [theme.breakpoints.up('sm')]: {
          pb: 3
        },
        pb: 3
      }}
    >
      {values.hardSkills?.map((skill, index) => (
        <DetailItem
          onEditItem={() => onEditHardSkill?.(index)}
          onDeleteItem={() => onDeleteHardSkill?.(index)}
          key={index}
          title={skill.name ?? ''}
          details={[
            {
              value: getTrans(
                skillLevelOptions.find(option => option.key === skill.level)
                  ?.value as keyof typeof getTrans
              )
            },
            ...(skill.professionallyUsed
              ? [
                  {
                    value: getTrans(
                      'cvBuilderPage.hardSkills.item.professionallyUsed.label'
                    )
                  }
                ]
              : [])
          ]}
          sx={{ pb: 1 }}
        />
      ))}
    </ItemListCard>
  );
};
